<template>
  <div >
    <ul v-if="messages && messages.length>0" class="w-11/12 md:w-full mx-auto">
      <li v-for="recipient in recipients" :key="recipient">
        <ul class="border
          border-beige-academy-300" >
          <li v-for="message in messagesToUser(recipient)" :key="message.id"
            class="p-4 text-sm border-b border-beige-academy-300 flex flex-col
               text-left bg-white" >
            <div class="flex flex-col">
              <div class="pr-4 text-xs text-gray-600 font-bold">
                 {{ message.to_user.name }}
              </div>
              <div class="text-xs">
                [ {{ message.subject }} ]
              </div>
            </div>
            <div class="text-sm text-black">
              {{ message.body }}
            </div>
            <div class="flex justify-end text-md pt-4">
              <button class="p-2 uppercase mr-4 px-4
              text-black"
                 @click="answer(message)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M8.31 189.9l176-151.1c15.41-13.3 39.69-2.509 39.69 18.16v80.05C384.6 137.9 512 170.1 512 322.3c0 61.44-39.59 122.3-83.34 154.1c-13.66 9.938-33.09-2.531-28.06-18.62c45.34-145-21.5-183.5-176.6-185.8v87.92c0 20.7-24.31 31.45-39.69 18.16l-176-151.1C-2.753 216.6-2.784 199.4 8.31 189.9z"/></svg>
              </button>
              <button class="p-2 uppercase px-4
              text-black"
                 @click="forward(message)" >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M503.7 226.2l-176 151.1c-15.38 13.3-39.69 2.545-39.69-18.16V272.1C132.9 274.3 66.06 312.8 111.4 457.8c5.031 16.09-14.41 28.56-28.06 18.62C39.59 444.6 0 383.8 0 322.3c0-152.2 127.4-184.4 288-186.3V56.02c0-20.67 24.28-31.46 39.69-18.16l176 151.1C514.8 199.4 514.8 216.6 503.7 226.2z"/></svg>
              </button>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <h5 v-else class="flex justify-center font-sans-serif text-sm mt-10 text-gray-500">
      {{$t('messages.none-sent')}}
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MessageForm from '@/components/modals/MessageForm.vue';

export default {
  data() {
    return {
      recipients: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      messages: 'auth/sentMessages',
    }),
  },

  mounted() {
    if (this.messages) this.setRecipients();
  },

  methods: {
    setRecipients() {
      this.recipients = [];
      this.messages.forEach((message) => {
        if (!this.recipients.includes(message.to_user_id)) this.recipients.push(message.to_user_id);
      });
    },

    messagesToUser(id) {
      if (this.messages) { return this.messages.filter((message) => message.to_user_id === id); }
      return '';
    },

    answer(message) {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: message.to_user, subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },

    forward(message) {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: '', subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },
  },

};

</script>
